module.exports = __webpack_public_path__ + "static/media/Corporate-partnership.ab58d790.svg";